export default __webpack_public_path__ + "static/agentic-automate-dark-a2a5becc3494c42256da78d7b3e255d6.png";